import { UserJsonWebToken } from '@sierralabs/core';
import { useApiGet } from '../../api/Api.hooks';
import { User } from '../../models/User';

export function useVerifyEmail() {
  const { data, isLoading, error, get } =
    useApiGet<UserJsonWebToken<User>>('users/verify/email');
  return { jwtToken: data, isLoading, error, verifyEmail: get };
}
